import { useEffect, useState } from "react";
import Slider from "react-slick";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useOrganization } from "../../store/organization";

import {Box} from "@mui/material";

const settingsMain = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  dots: false,
  initialSlide: 4,
};

const settingsThumbs = {
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  centerMode: true,
  swipeToSlide: true,
  focusOnSelect: true,
  centerPadding: '10px',
  arrows: false,
  dots: false,
  initialSlide: 4,
};

export function ImageGallery() {
  const isMobile = useMediaQuery("(max-width:600px)");

  const { organization } = useOrganization();
  const landingDetails = organization.data.landingDetails;

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);

  }, [slider1, slider2]);

  return (
    <div className="tw-mt-8 md:tw-mt-20">
      <div className="slider-wrapper">

        <Slider
          {...settingsMain}
          asNavFor={nav2}
          ref={slider => (setSlider1(slider))}
        >
          {landingDetails.gallery.map((imageUrl, key) =>
            <Box
              key={key}
              className="slick-slide"
              sx={{
                width: 600,
                height: 600,
                backgroundImage: `url(${imageUrl})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center"
              }}
            />
          )}
        </Slider>

        <div className="thumbnail-slider-wrap tw-mt-4">
          <Slider
            {...settingsThumbs}
            asNavFor={nav1}
            ref={slider => (setSlider2(slider))}>

            {landingDetails.gallery.map((imageUrl, key) =>
              <Box
                key={key}
                className="slick-slide"
                sx={{
                  width: 140,
                  height: 140,
                  backgroundImage: `url(${imageUrl})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center"
                }}
              />
            )}
          </Slider>
        </div>
      </div>
    </div>
  );
}
